import Modal from '@/components/common/modals/Modal';
import PlentyFullScreenSpinner from '@/components/common/PlentyFullScreenSpinner';
import PlentyLogo from '@/components/common/PlentyLogo';
import ModalManager, { useModal } from '@/components/ModalManager';
import AcceptInviteIntroView from '@/components/partnershipInvites/AcceptInviteIntroView';
import AcceptInviteSharingView from '@/components/partnershipInvites/AcceptInviteSharingView';
import AcceptInviteSummaryView from '@/components/partnershipInvites/AcceptInviteSummaryView';
import { useTrackModalShown } from '@/services/analytics/useTracking';
import { Box } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import React, { useState } from 'react';

// TODO: This code is not currently called anywhere - decide if we want to delete it bring it back
// https://linear.app/plenty/issue/PLE-1371/bring-back-or-delete-acceptinvitemodal
export const showAcceptInvitePartnerModal = () =>
    ModalManager.show(AcceptInviteModal, {});

type AcceptInvitePosition =
    | 'intro'
    | 'sharing'
    | 'summary'
    | 'post-invite-animation'
    | 'post-invite-walkthrough';

const AcceptInviteModal = ModalManager.create(() => {
    useTrackModalShown('Accept Invite');
    const modal = useModal();
    const router = useRouter();
    const [position, setPosition] = useState<AcceptInvitePosition>('intro');

    if (position === 'post-invite-animation') {
        return (
            <PlentyFullScreenSpinner
                spinnerSize={80}
                dynamicLines={['Accepting invite', 'Updating your dashboard']}
                onDynamicLinesComplete={async () => {
                    modal.hide();
                    setPosition('intro');
                    router.push('/');
                }}
            />
        );
    }

    return (
        <Modal
            size="4xl"
            isOpen={modal.visible}
            scrollBehavior="outside"
            onClose={modal.hide}
            isCentered={false}
            modalContentProps={{ my: 8 }}
        >
            <Box>
                {position !== 'intro' && (
                    <Box mb={10}>
                        <PlentyLogo width={45} />
                    </Box>
                )}

                {position === 'intro' && (
                    <AcceptInviteIntroView
                        onNext={() => setPosition('sharing')}
                        onBack={() => modal.hide()}
                    />
                )}

                {position === 'sharing' && (
                    <AcceptInviteSharingView
                        onNext={() => setPosition('summary')}
                    />
                )}

                {position === 'summary' && (
                    <AcceptInviteSummaryView
                        onBack={() => setPosition('sharing')}
                        onNext={() => setPosition('post-invite-animation')}
                    />
                )}
            </Box>
        </Modal>
    );
});

export default AcceptInviteModal;
